import template from '../xps-product-finder-detail/xps-product-finder-detail.html.twig';

const { Component } = Shopware;

Component.extend('xps-product-finder-create', 'xps-product-finder-detail', {
    template,

    methods: {
        getProductFinder() {
            this.productFinder = this.repository.create(Shopware.Context.api);
            this.productFinder.active = true;
            this.productFinder.position = 0;
        },

        onSave() {
            this.isLoading = true;

            this.repository.save(this.productFinder, Shopware.Context.api)
                .then(() => {
                    this.isLoading = false;
                    this.$router.push({ 
                        name: 'xps.product.finder.detail', 
                        params: { id: this.productFinder.id } 
                    });
                })
                .catch((exception) => {
                    this.isLoading = false;
                    this.createNotificationError({
                        title: this.$tc('xps-product-finder.detail.errorTitle'),
                        message: exception
                    });
                });
        }
    }
});